import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true
});

// STEP 8-I-3A · Real-device HOTFIX
// 일부 모바일 브라우저(iOS Safari · 3rd-party cookie 차단 등)에서 httpOnly
// session_token 쿠키가 API 요청에 실리지 않아 판매자 인증이 실패한다.
// localStorage 에 session_token 이 있으면 Authorization: Bearer 헤더를 자동 주입해
// 쿠키가 안 실리는 상황에서도 판매자 view(Unmask) 가 정상 동작하도록 한다.
api.interceptors.request.use((config) => {
  try {
    const t = typeof window !== 'undefined' && window.localStorage
      ? window.localStorage.getItem('session_token')
      : null;
    if (t && config && config.headers && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${t}`;
    }
  } catch (_) { /* localStorage 접근 불가 시 조용히 pass */ }
  return config;
});

// /auth/me · /auth/session 응답이 session_token 을 포함하면 자동으로 localStorage
// 에 하이드레이트(구 세션 · 쿠키만 있는 사용자도 다음 요청부터 헤더 인증 사용).
// /auth/logout 응답 시 자동 제거.
api.interceptors.response.use((response) => {
  try {
    const url = (response && response.config && response.config.url) || '';
    if (typeof window === 'undefined' || !window.localStorage) return response;
    if (url.includes('/auth/logout')) {
      window.localStorage.removeItem('session_token');
      return response;
    }
    const tok = response && response.data && response.data.session_token;
    if (tok && (url.includes('/auth/me') || url.includes('/auth/session'))) {
      window.localStorage.setItem('session_token', tok);
    }
  } catch (_) { /* ignore */ }
  return response;
});

export default api;
